export enum RouteName {
  List = 'merchant-settlement-list',
  Detail = 'merchant-settlement-detail',
}
